import React from 'react';
import { Tooltip } from 'antd';
import { LayoutGrid } from 'lucide-react';
import { useEditorCanvas } from '../../canvas/hooks/use-editor-canvas';
import { TabBtn } from '../../shared/ui/tab-btn';
import { useGrouping } from '../hooks/use-grouping';

export const CreateGridCollectionButton: React.FC = () => {
  const { canvas, transaction } = useEditorCanvas();
  const { canGroup, createGridCollection } = useGrouping(canvas, transaction);

  const btn = (
    <TabBtn onClick={createGridCollection} label='Grilla' icon={<LayoutGrid size={18} />} disabled={!canGroup} />
  );

  if (canGroup) return btn;

  return (
    <Tooltip title='Seleccioná 2 o más elementos para crear una grilla' placement='left'>
      {btn}
    </Tooltip>
  );
};
